module.exports = __webpack_public_path__ + "static/media/choose-battle-bg.4dc33276.png";